import sso from './sso';
import licenseLimit from './license-limit';

export default {
  sso,
  'license-limit': licenseLimit,
};
